/**
 * ENG-3627 — Overview's chunk, in a module of its own so `DashboardLayout`'s `React.lazy` and App's
 * prefetch ask webpack for the same module (one download, one module instance) without App importing
 * `DashboardLayout`, which is itself a lazy chunk (ENG-3620).
 */
export const loadOverviewPage = () => import("../pages/OverviewPage");
